import { useEffect, useRef, useState } from 'react'
import { PieChart } from 'react-minimal-pie-chart'

import { CircleProgressBarAnimation } from '~/shared/utils/circleProgressBarAnimation.utils'
import getCleanPercentage from '~/shared/utils/getCleanPercentage.utils'

export default function CircleProgressBar({
  colorStart,
  colorStop,
  percentage,
  textColor = 'text-black',
}: {
  colorStart: string
  colorStop: string
  percentage: number
  textColor?: string
}): React.ReactElement {
  const [value, setValue] = useState(0)
  const [pct, setPct] = useState(getCleanPercentage(percentage))
  const gradientIdRef = useRef<string>(`circleGradient-${Math.random().toString(36)}`) // Need to store ID in ref becouse safari

  useEffect(() => {
    CircleProgressBarAnimation({
      start: value,
      end: percentage,
      duration: 300,
      onUpdate: (currentValue) => {
        setPct(currentValue)
      },
      onComplete: () => setValue(percentage),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [percentage])

  return (
    <div className="relative w-14 h-14 flex items-center justify-center m-3">
      <PieChart
        className="absolute top-0 left-0"
        data={[{ value: 100, color: 'lightgrey' }]}
        lineWidth={23}
        startAngle={-90}
        totalValue={100}
      />

      <PieChart
        animate
        className="absolute top-0 left-0"
        data={[
          { value: pct, color: `url(#${gradientIdRef.current})` },
          { value: 100 - pct, color: 'transparent' },
        ]}
        lineWidth={23}
        startAngle={-90}
        totalValue={100}
      >
        <defs>
          <linearGradient id={gradientIdRef.current} x2="0.35" y2="1">
            <stop offset="0%" stopColor={colorStart} />
            <stop offset="100%" stopColor={colorStop} />
          </linearGradient>
        </defs>
      </PieChart>

      <div className="absolute text-center">
        <span className={textColor}>{percentage.toFixed(0)}%</span>
      </div>
    </div>
  )
}
